export const totalSeries = [
  0, 95, 12, 130, 10, 180, 110, 155, -20, -120, -60, -110, -300, -330, -390, -265, -145, -70, -55,
  -98, -210, -115, -50, -260, -180, -420, -130, -290, -350, 480, 575, 420, 550, 470, 332,
];

export const nonShowdownSeries = totalSeries.map((_, i) =>
  Math.round(-i * 31 + Math.sin(i * 0.7) * 52),
);

export const showdownSeries = totalSeries.map((value, i) => value - nonShowdownSeries[i]);

export type PostflopGroup = 'General' | 'Preflop' | 'Donk' | 'CBet' | 'B/x';

export const postflopSets: Record<
  PostflopGroup,
  {
    heads: string[];
    labels?: string[];
    rows: (number | null)[][];
  }
> = {
  General: {
    heads: [
      'CBet',
      'FvCb',
      'RCb',
      'Bet',
      'B-F',
      'FvBet',
      'RBet',
      'W after R',
      'Donk',
      'xR',
      'Agf %',
    ],
    rows: [
      [60, 49, 7, 42, null, 56, 7, null, null, 0, 40],
      [38, 44, 5, 35, null, 50, 6, null, null, 0, 31],
      [64, 30, 20, 47, null, 47, 8, 100, null, null, 40],
    ],
  },
  Preflop: {
    heads: ['TOT', 'EP', 'MP', 'CO', 'BTN', 'SB', 'BB'],
    labels: ['R1', 'F3b', '4bet'],
    rows: [
      [18, 12, 15, 25, 38, 31, null],
      [68, 71, 70, 66, 63, 61, 70],
      [14, 9, 10, 13, 18, 15, 11],
    ],
  },
  Donk: {
    heads: ['Donk', 'D 3bp', 'FvD', 'D-fold'],
    rows: [
      [null, null, 44, null],
      [null, null, 37, null],
      [null, null, 51, null],
    ],
  },
  CBet: {
    heads: ['Cb IP', 'Cb OOP', 'Cb-F IP', 'Cb-F OOP', 'Cb-c&f t', 'Cb-c&c t&f r'],
    rows: [
      [66, 52, 37, 41, null, null],
      [42, 33, null, null, 48, null],
      [67, 59, null, null, null, 32],
    ],
  },
  'B/x': {
    heads: ['bxb TOT', 'bxf TOT', 'bxb IP', 'bxf IP', 'B-F', 'B-c&f t'],
    rows: [
      [null, null, null, null, 35, null],
      [null, null, null, null, 41, 48],
      [29, 43, 33, 47, 38, null],
    ],
  },
};

export const preflopPairs: [string, string | number][] = [
  ['3bet', 8],
  ['WTSD', 31],
  ['Call3bet', 18],
  ['F3bet', 68],
  ['WWSF', 48],
  ['4bet', 14],
  ['SQZ', 5],
  ['W$SD', 56],
  ['F4bet', 57],
  ['CC', 6],
  ['5bet', 22],
  ['SB / BB resteal', '11 / 11'],
];

export const dateLabels: Record<string, string> = {
  all: 'Всё время',
  month: 'Последние 30 дней',
  week: 'Последние 7 дней',
};

export type StatView = 'overview' | 'history' | 'summary';

export type FilterState = {
  format: string;
  limit: string;
  period: 'all' | 'month' | 'week';
};

export function dataIsFiltered(filters: FilterState) {
  return (
    filters.period === 'month' || filters.format !== 'Все форматы' || filters.limit !== 'Все лимиты'
  );
}

export function getDemoValues(filters: FilterState) {
  if (dataIsFiltered(filters)) {
    return {
      hands: '5.2K',
      fullHands: '5 200',
      winrate: '−0.8',
      winnings: '+$126',
      ratio: '18 / 14',
      factor: 126 / 332,
    };
  }

  return {
    hands: '13K',
    fullHands: '13 000',
    winrate: '−1.1',
    winnings: '+$332',
    ratio: '16 / 13',
    factor: 1,
  };
}

export const topPlayersDemo = [
  { rank: 1, name: 'AceRiver', room: 'PS', hands: '42K', winrate: '4.2', winnings: '+$1 240' },
  { rank: 2, name: 'FoldMaster', room: 'WPN', hands: '38K', winrate: '3.8', winnings: '+$980' },
  { rank: 3, name: 'RiverDemo', room: 'WPN', hands: '13K', winrate: '−1.1', winnings: '+$332' },
  { rank: 4, name: 'BluffKing', room: '888', hands: '29K', winrate: '2.1', winnings: '+$710' },
  { rank: 5, name: 'TightNit', room: 'CHICO', hands: '21K', winrate: '1.4', winnings: '+$540' },
];

export type SubscriptionPlanTier = {
  label: string;
  price: string;
  highlight?: boolean;
};

export type SubscriptionPlanIcon = 'networks' | 'coin' | 'ipoker' | 'all';

export type SubscriptionPlan = {
  id: string;
  title: string;
  subtitle?: string;
  icon: SubscriptionPlanIcon;
  featured?: boolean;
  tiers: SubscriptionPlanTier[];
  details?: string[];
};

export const subscriptionPromos = [
  {
    id: 'promo-3m',
    title: '3 месяца',
    discount: '−10%',
    description: 'При покупке подписки на 3 месяца',
    tone: 'warm' as const,
  },
  {
    id: 'promo-6m',
    title: '6 месяцев',
    discount: '−25%',
    description: 'При покупке на 6 месяцев',
    tone: 'cool' as const,
  },
];

export const subscriptionPlans: SubscriptionPlan[] = [
  {
    id: 'networks',
    title: 'PS + WPN + 888 + CHICO',
    subtitle: 'Основные сети',
    icon: 'networks',
    featured: true,
    tiers: [
      { label: 'NL 10–50', price: '15 $ / мес' },
      { label: 'UNLIM', price: '30 $ / мес', highlight: true },
    ],
    details: ['PS (10–200, частично NL500)', '888 (10–5K)', 'WPN (10–600)', 'CHICO (10–500)'],
  },
  {
    id: 'coin',
    title: 'COIN',
    icon: 'coin',
    tiers: [
      { label: 'NL 10–50', price: '15 $ / мес' },
      { label: 'NL 10–200', price: '20 $ / мес' },
      { label: 'UNLIM NL10–1K', price: '35 $ / мес', highlight: true },
    ],
  },
  {
    id: 'ipoker',
    title: 'iPoker',
    icon: 'ipoker',
    tiers: [
      { label: 'NL 10–50', price: '12 $ / мес' },
      { label: 'NL 10–200', price: '20 $ / мес' },
    ],
  },
  {
    id: 'all',
    title: 'Все румы сразу',
    subtitle: 'Максимальный охват',
    icon: 'all',
    featured: true,
    tiers: [
      { label: 'NL 10–25', price: '12 $ / мес' },
      { label: 'NL 10–50', price: '20 $ / мес' },
      { label: 'NL 10–200', price: '35 $ / мес' },
      { label: 'NL UNLIM', price: '45 $ / мес', highlight: true },
    ],
  },
];

export const faqItems = [
  {
    question: 'Как искать игроков?',
    answer:
      'Введите ник в строку поиска на странице «Игроки» или используйте расширение для автопоиска из буфера обмена.',
  },
  {
    question: 'Что означают показатели Preflop?',
    answer:
      'Preflop показывает агрессию и частоту действий до флопа: 3bet, 4bet, fold to 3bet, squeeze и другие ключевые метрики.',
  },
  {
    question: 'Как работает режим «Фокус»?',
    answer:
      'Компактный режим убирает лишние элементы и оставляет KPI и график — удобно рядом с покерным столом.',
  },
  {
    question: 'Как подключить расширение?',
    answer:
      'Установите расширение Fish Hunter в Chrome, авторизуйтесь и включите автопоиск в настройках расширения.',
  },
];
